import React from 'react';

import EditableSqlReportRow from 'components/SqlReport/EditableSqlReportRow';

const SqlReportQueryTable = ({ sqlReportQuery, handleSaveField }) => {
  const {
    id,
    name,
    enabled,
    attach_only_with_results,
    google_sheet_name,
    google_sheet_column_range,
    report_id,
  } = sqlReportQuery || {};

  return (
    <table className="table sql-report-table">
      <tbody>
        <tr>
          <th style={{ minWidth: '210px', width: '210px' }}>Id</th>
          <td>{id}</td>
          <td></td>
        </tr>
        <EditableSqlReportRow
          label="Name"
          name="name"
          value={name}
          type="input"
          save={handleSaveField}
        />
        <EditableSqlReportRow
          label="Enabled"
          name="enabled"
          value={enabled}
          type="select"
          save={handleSaveField}
        />
        <EditableSqlReportRow
          label="Attach only with results"
          name="attach_only_with_results"
          value={attach_only_with_results}
          type="select"
          save={handleSaveField}
        />
        <EditableSqlReportRow
          label="Google sheet name"
          name="google_sheet_name"
          value={google_sheet_name}
          type="input"
          save={handleSaveField}
        />
        <EditableSqlReportRow
          label="Google sheet column range"
          name="google_sheet_column_range"
          value={google_sheet_column_range || ''}
          type="input"
          save={handleSaveField}
        />
        <tr>
          <th>Report id</th>
          <td>{report_id}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  );
};

export default SqlReportQueryTable;
